export default __webpack_public_path__ + "d0306d3e5b0f8007380f29c57ad92dd0.png";